module.exports = "/images/arrow-1.svg?ffe655d6189e48e70755c4221cbc4d9d";